// @ts-check
import { getCasePropSelector } from '../utils/case-prop-selector'
import { nullIfEmpty } from '../utils/object'
import { createSelector } from '../utils/selector-utils'

export const selectHealthQuestionsSummary = createSelector(
  getCasePropSelector('surgicalHistorySummary'),
  getCasePropSelector('anesthesiaHistorySummary'),
  getCasePropSelector('familyAnesthesiaHistorySummary'),
  getCasePropSelector('hospitalizationSummary'),
  (
    surgicalHistorySummary,
    anesthesiaHistorySummary,
    familyAnesthesiaHistorySummary,
    hospitalizationSummary
  ) => {
    const result = []

    if (hospitalizationSummary) {
      result.push([
        'Non-surgical hospitalization summary',
        hospitalizationSummary,
      ])
    }
    if (surgicalHistorySummary) {
      result.push(['Surgeries', surgicalHistorySummary])
    }
    if (anesthesiaHistorySummary) {
      result.push(['Personal anesthesia history', anesthesiaHistorySummary])
    }
    if (familyAnesthesiaHistorySummary) {
      result.push([
        'Familial anesthesia history',
        familyAnesthesiaHistorySummary,
      ])
    }

    return nullIfEmpty(result)
  }
)

/** @type {CaseSelector<string | null>} */
export const selectMedicalConsultNotes = createSelector(
  getCasePropSelector('medicalConsult'),
  getCasePropSelector('medicalConsultNotes'),
  (medicalConsult, medicalConsultNotes) =>
    (medicalConsult && medicalConsultNotes) || null
)

/** @type {CaseSelector<string>} */
export const selectPatientMedicationSummary = createSelector(
  getCasePropSelector('medications'),
  getCasePropSelector('medicationsText'),
  (medications, medicationsText) =>
    medicationsText ||
    (medications && medications.map(item => item.name).join(', ')) ||
    ''
)

/**
 * @type {Pick<
 *   Record<keyof CaseData, string>,
 *   'brodsky' | 'ulbt' | 'tmd' | 'iid' | 'mallampati'
 * >}
 */
export const airwayAssessmentLabelMap = {
  mallampati: 'Modified Mallampati',
  brodsky: 'Tonsil Size (Brodsky scale)',
  ulbt: 'Upper lip bite test',
  tmd: 'Thyromental Distance (in cm)',
  iid: 'Inter-incisor Distance (in cm)',
}

const airwayKeys = Object.keys(airwayAssessmentLabelMap)
const airwayLabels = Object.values(airwayAssessmentLabelMap)

/**
 * @type {CaseSelector<
 *   { name: string; label: string; value: string }[] | null
 * >}
 */
export const selectAirwayAssessmentReport = createSelector(
  // @ts-ignore
  ...airwayKeys.map(key => getCasePropSelector(key)),
  (...values) => {
    const result = []
    for (let i = 0; i < airwayKeys.length; i++) {
      const label = airwayLabels[i]
      const value = values[i]
      const key = airwayKeys[i]
      result.push({ name: key, label, value })
    }
    return result
  }
)
